/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { DosespotMedication } from "./DosespotMedication";
import type { FetchRxHistoryWorkflowStatusStatus } from "./FetchRxHistoryWorkflowStatusStatus";

export interface FetchRxHistoryWorkflowStatus {
  status: FetchRxHistoryWorkflowStatusStatus;
  medications?: DosespotMedication[] | null;
  non_renewable_medications?: DosespotMedication[] | null;
  error?: string | null;
}
